import {
    ICorporationResponse,
    ICurrentUserResponse,
    ILocationResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { User } from 'configcat-react';

type BuildConfigCatUserOptions = Readonly<{
    user: ICurrentUserResponse;
    corporation?: ICorporationResponse;
    location?: ILocationResponse;
}>;

/**
 * Builds a ConfigCat `User` from the app's current user identity and
 * optional route-level corporation/location context. The returned object
 * is used by `setDefaultUser` so that all `useFeatureFlag` evaluations
 * include targeting attributes like role, corporation, and location.
 */
export function buildConfigCatUser({
    user,
    corporation,
    location,
}: BuildConfigCatUserOptions): User {
    return new User(user.Id, user.Email, undefined, {
        role: user.ApplicationRole,
        corporations: user.Corporations.map((c) => c.CorporationName),
        corporationIds: user.Corporations.map((c) => c.CorporationId),
        locations: user.Locations.map((l) => l.LocationName),
        locationIds: user.Locations.map((l) => l.LocationId),
        ...(corporation && {
            currentCorporationId: corporation.Id,
            currentCorporationName: corporation.Name,
            currentAccessLevel: corporation.AccessLevel,
        }),
        ...(location && {
            currentLocationId: location.Id,
            currentLocationName: location.Name,
        }),
    });
}
